<ng-content></ng-content>
<ng-container [ngSwitch]="loader" *ngIf="isLoading">
  <div class="load-container" [class.cs-load-top]="isLoadTop">
    <div id="circle-loader" *ngSwitchCase="'circle'"></div>
    <div class="cs-load-thecube" *ngSwitchCase="'cube'">
      <div class="cs-load-cube cs-load-c1"></div>
      <div class="cs-load-cube cs-load-c2"></div>
      <div class="cs-load-cube cs-load-c4"></div>
      <div class="cs-load-cube cs-load-c3"></div>
    </div>
    <div class="cs-load-loader" *ngSwitchCase="'flip'">
      <div class="cs-load-flipper">
        <div class="cs-load-front"></div>
        <div class="cs-load-back"></div>
      </div>
    </div>
    <div *ngIf="displayMessage" class="mt-20">
      {{ displayMessage }}
    </div>
  </div>
</ng-container>
